import React from "react";
import "../styles/main.css";
import { useNavigate } from "react-router-dom";
import {
  FaArrowUp,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt
} from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">

      <div className="footer-container">

        {/* LINKS */}
        <div className="footer-col">
          <h3>Links</h3>

          <ul>
            <li onClick={() => navigate("/about")}>
              About Us
            </li>

            <li onClick={() => navigate("/contact")}>
              Contact
            </li>

            <li onClick={() => navigate("/news")}>
              News
            </li>

            <li onClick={() => navigate("/gallery")}>
              Gallery
            </li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-col">
          <h3>Contacts</h3>

          <p>
            <FaMapMarkerAlt />
            NAV JEEVAN MISSION INTERNATIONAL SCHOOL
          </p>

          <p>
            <FaEnvelope />
            njms.gorakhpur@gmail.com
          </p>

          <p>
            <FaPhoneAlt />
            +91-7081803501, +91-7081803502
          </p>

          <p>
            NAV JEEVAN NAGAR, MEDICAL COLLEGE ROAD, GULHARIYA, GORAKHPUR-273013 (U.P.)
          </p>

        </div>

        {/* MEDIA */}
        <div className="footer-col">
          <h3>Media Links</h3>

          <div className="social-icons">

            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.linkedin.com/login"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedinIn />
            </a>

            <a
              href="https://www.youtube.com/account"
              target="_blank"
              rel="noreferrer"
            >
              <FaYoutube />
            </a>

          </div>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-disclaimer">

        <span>
          © Nav Jeevan International 2018-19
        </span>

        <a
          href="http://www.ilakshya.in/"
          target="_blank"
          rel="noreferrer"
          className="footer-powered-link"
        >
          Powered by iLakshya Total Solutions
        </a>


      </div>

      {/* TOP BUTTON */}
      <button
        className="scroll-top-btn"
        onClick={scrollToTop}
      >
        <FaArrowUp />
      </button>

    </footer>
  );
};

export default Footer;